import React from 'react';
import GroupToken from './GroupToken';

export default function And(props) {
	return <GroupToken operator="and" label="&and;" border="success" {...props} />;
}
